document.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector(".larea-page");
  let appliedLeftGap = 0;

  const normalizeShopifyEmbed = () => {
    if (!page) return;
    const wrapperSelectors = [
      ".rte",
      ".rte-formatter",
      ".section",
      ".spacing-style",
      ".layout-panel-flex",
      ".section-content-wrapper",
      ".mobile-column",
      ".page-width",
      ".shopify-section",
    ];
    const wrappers = wrapperSelectors
      .map((selector) => page.closest(selector))
      .filter(Boolean);

    wrappers.forEach((wrapper) => {
      Object.assign(wrapper.style, {
        boxSizing: "border-box",
        marginTop: "0",
        marginBottom: "0",
        paddingTop: "0",
        paddingBottom: "0",
        paddingLeft: "0",
        paddingRight: "0",
        paddingInline: "0",
        maxWidth: "none",
        minWidth: "0",
      });
    });

    Object.assign(page.style, {
      left: "0",
      marginLeft: "0",
      marginRight: "0",
    });

    const fullBleedWrappers = [
      page.closest(".shopify-section"),
      page.closest(".page-width"),
      page.closest(".rte"),
      page.closest(".rte-formatter"),
      page.closest(".section"),
      page.closest(".section-content-wrapper"),
      page.closest(".layout-panel-flex"),
      page.closest(".mobile-column"),
      page.closest(".spacing-style"),
    ].filter(Boolean);

    fullBleedWrappers.forEach((wrapper) => {
      Object.assign(wrapper.style, {
        width: "100vw",
        maxWidth: "100vw",
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
      });
    });

    if (window.matchMedia("(max-width: 680px)").matches) {
      appliedLeftGap = 0;
      fullBleedWrappers.forEach((wrapper) => {
        Object.assign(wrapper.style, {
          width: "100%",
          maxWidth: "100%",
          marginLeft: "0",
          marginRight: "0",
          paddingLeft: "0",
          paddingRight: "0",
        });
      });

      const rteWrapper = page.closest(".rte");
      if (rteWrapper) {
        Object.assign(rteWrapper.style, {
          padding: "0",
          paddingInline: "0",
        });
      }

      const sectionWrapper = page.closest(".section");
      if (sectionWrapper) {
        sectionWrapper.style.display = "block";
      }

      const mobileColumnWrapper = page.closest(
        ".spacing-style.layout-panel-flex.layout-panel-flex--column.section-content-wrapper.mobile-column"
      );
      if (mobileColumnWrapper) {
        Object.assign(mobileColumnWrapper.style, {
          width: "100vw",
          maxWidth: "100vw",
          marginLeft: "calc(50% - 50vw)",
          marginRight: "calc(50% - 50vw)",
          paddingLeft: "0",
          paddingRight: "0",
        });
      }

      page.style.left = "0";
      page.style.width = "100%";
      page.style.maxWidth = "100%";
      page.style.marginLeft = "auto";
      page.style.marginRight = "auto";
      page.style.paddingLeft = "max(10px, env(safe-area-inset-left))";
      page.style.paddingRight = "max(10px, env(safe-area-inset-right))";
      page.style.transform = "";
      return;
    }

    requestAnimationFrame(() => {
      const currentLeft = page.getBoundingClientRect().left;
      const leftGap = Math.max(0, Math.round(currentLeft + appliedLeftGap));
      if (leftGap === appliedLeftGap) return;
      appliedLeftGap = leftGap;
      if (appliedLeftGap > 1) {
        page.style.width = `calc(100% + ${leftGap}px)`;
        page.style.maxWidth = `calc(100% + ${leftGap}px)`;
        page.style.transform = `translateX(-${leftGap}px)`;
        page.style.paddingRight = `${leftGap}px`;
      } else {
        page.style.width = "100%";
        page.style.maxWidth = "100%";
        page.style.transform = "";
        page.style.paddingRight = "0";
      }
    });
  };

  let normalizeQueued = false;
  const scheduleNormalizeShopifyEmbed = () => {
    if (normalizeQueued) return;
    normalizeQueued = true;
    requestAnimationFrame(() => {
      normalizeQueued = false;
      normalizeShopifyEmbed();
    });
  };

  normalizeShopifyEmbed();
  [120, 500, 1200].forEach((delay) => {
    window.setTimeout(scheduleNormalizeShopifyEmbed, delay);
  });

  window.addEventListener("resize", scheduleNormalizeShopifyEmbed, {
    passive: true,
  });
  window.addEventListener("load", scheduleNormalizeShopifyEmbed, {
    passive: true,
  });

  const topBtn = document.querySelector(".top-btn");
  topBtn?.addEventListener("click", () =>
    window.scrollTo({ top: 0, behavior: "smooth" })
  );

  document.querySelectorAll(".movie-card").forEach((card) => {
    const playButton = card.querySelector(".play");
    const triggerButton = card.querySelector(".movie-trigger");
    const closeButton = card.querySelector(".movie-close");
    const player = card.querySelector(".movie-player");
    const video = card.querySelector("video");

    const playMovie = () => {
      if (!player) return;
      document.body.appendChild(player);
      player.classList.add("is-open");
      player?.setAttribute("aria-hidden", "false");
      video?.play?.();
    };

    const closeMovie = () => {
      video?.pause?.();
      if (video) video.currentTime = 0;
      player?.classList.remove("is-open");
      player?.setAttribute("aria-hidden", "true");
      if (player && player.parentElement !== card) card.appendChild(player);
    };

    playButton?.addEventListener("click", playMovie);
    triggerButton?.addEventListener("click", playMovie);
    closeButton?.addEventListener("click", closeMovie);
    player?.addEventListener("click", (event) => {
      if (event.target === player || event.target.closest(".movie-backdrop"))
        closeMovie();
    });
  });

  const products = document.querySelector(".products");
  if (products) {
    const baseProducts = [...products.querySelectorAll(".product")];
    const totalItems = 8;
    for (let index = baseProducts.length; index < totalItems; index += 1) {
      const source = baseProducts[index % baseProducts.length];
      const clone = source.cloneNode(true);
      clone.classList.add("pc-extra");
      products.appendChild(clone);
    }
  }

  document.querySelectorAll(".lineup-arrow").forEach((button) => {
    button.addEventListener("click", () => {
      const slider = button.closest(".lineup-slider")?.querySelector(".products");
      const firstItem = slider?.querySelector(".product");
      if (!slider || !firstItem) return;
      const gap =
        Number.parseFloat(getComputedStyle(slider).columnGap || "18") || 18;
      const step = firstItem.getBoundingClientRect().width + gap;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const isNext = button.classList.contains("next");
      const target = isNext
        ? slider.scrollLeft >= maxScroll - step / 2
          ? 0
          : slider.scrollLeft + step
        : slider.scrollLeft <= step / 2
        ? maxScroll
        : slider.scrollLeft - step;
      slider.scrollTo({
        left: target,
        behavior: "smooth",
      });
    });
  });

  const collectionGrid = document.querySelector(".mobile-collection-grid");
  if (collectionGrid) {
    const productItems = [...document.querySelectorAll(".product")]
      .map((product) => {
        const link = product.querySelector(".product-image a");
        const image = product.querySelector(".product-image img");
        return { image, href: link?.getAttribute("href") || "#" };
      })
      .filter((item) => item.image);

    const tabs = [...document.querySelectorAll(".mobile-tabs button")];
    const collections = {
      all: productItems.slice(0, 8),
      "one-piece": productItems.slice(4, 8),
      tops: [productItems[0], productItems[2]].filter(Boolean),
      skirt: [productItems[1], productItems[3]].filter(Boolean),
    };

    const renderCollection = (category = "all") => {
      collectionGrid.replaceChildren();
      (collections[category] || collections.all).forEach((item, index) => {
        const link = document.createElement("a");
        const thumb = document.createElement("img");
        link.href = item.href;
        thumb.src = item.image.src;
        thumb.alt = item.image.alt || `ぬん姉さん コレクション ${index + 1}`;
        thumb.loading = "lazy";
        link.appendChild(thumb);
        collectionGrid.appendChild(link);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((button) =>
          button.classList.toggle("is-active", button === tab)
        );
        renderCollection(tab.dataset.category);
      });
    });
    renderCollection("all");
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
});